// List mode: the same window of meetings as a table.
//
// NOT A DIFFERENT QUESTION — the same rows the grid draws, ordered by time. The grid
// answers "what does my week look like"; the list answers "what is coming up", which is
// the better shape when you want to read the summaries or scan a long month.
//
// The status pill is local rather than the shared StatusBadge. A meeting's state on screen
// is not one column: "התקיימה" is derived (it has a summary) while "מבוטלת" is stored, and
// StatusBadge maps a single stored value per kind. Teaching it a two-column rule for one
// screen would make every other caller carry the complication.
import he from '../../i18n/he';
import DataTable from '../../components/DataTable';
import DateText from '../../components/DateText';
import { dotStyle } from './meetingColors';
import { isCancelled, isExternal, isHeld, isInternal } from './meetingKind';
import { meetingLabel } from './MeetingChip';

const StatePill = ({ meeting }) => {
  if (isCancelled(meeting)) return <span className="badge gray">{he.calendar.cancelled}</span>;
  if (isHeld(meeting)) return <span className="badge green">{he.calendar.held}</span>;
  return <span className="badge blue">{he.calendar.scheduled}</span>;
};

// `withSummary` is the search's shape (077): a match may be in the summary, so the result
// shows the start of it under the name.
export default function MeetingList({ meetings, partners, onOpen, withSummary = false, emptyText = he.calendar.empty }) {
  const columns = [
    {
      key: 'when',
      label: he.calendar.colWhen,
      render: (m) => <DateText value={m.meeting_date} />,
      sortable: false,
    },
    {
      key: 'time',
      label: he.calendar.colTime,
      render: (m) => `${m.start_time}–${m.end_time}`,
      sortable: false,
    },
    {
      key: 'with',
      label: he.calendar.colWith,
      primary: true,
      render: (m) => (
        <span className="list-with">
          <span className="meeting-dot" style={dotStyle(m, partners)} />
          <span className={isCancelled(m) ? 'struck' : undefined}>{meetingLabel(m)}</span>
          {m.job_title && <span className="muted small-note"> · {m.job_title}</span>}
          {isInternal(m) && <span className="muted small-note"> · {he.calendar.internalLabel}</span>}
          {isExternal(m) && <span className="muted small-note"> · {he.calendar.externalBadge}</span>}
          {withSummary && m.summary && <span className="list-summary muted">{m.summary.slice(0, 140)}</span>}
        </span>
      ),
      sortable: false,
    },
    {
      key: 'owner',
      label: he.calendar.colOwner,
      render: (m) => (isInternal(m) ? `${m.owner_name} · ${m.with_name}` : m.owner_name),
      sortable: false,
    },
    {
      key: 'status',
      label: he.calendar.colStatus,
      render: (m) => <StatePill meeting={m} />,
      sortable: false,
    },
  ];

  return (
    <DataTable
      columns={columns}
      rows={meetings}
      onRowClick={onOpen}
      rowClass={(m) => (isCancelled(m) ? 'row-cancelled' : '')}
      empty={{ text: emptyText }}
    />
  );
}
